import axiosInstance from '.';

export const createCheckoutSession = async (callbackUrl: string): Promise<StripeCheckoutSession> => {
  // TODO: change to rtk
  const response = await axiosInstance.post('/v1/payments/create-checkout-session', { callbackUrl });

  return response.data;
};
